(() => {
  if (!('IntersectionObserver' in window) || window.Shopify?.designMode || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  // The reference reveals heading words from below their line at 85% of the viewport.
  const headingSelector = [
    '#MainContent .solari-hero__eyebrow',
    '#MainContent .solari-hero h1',
    '#MainContent .solari-inner-banner :is(h1,h2)',
    '#MainContent .solari-section-heading .solari-kicker',
    '#MainContent .solari-section-heading h2',
    '#MainContent .solari-mission .solari-kicker',
    '#MainContent .solari-mission h2',
    '#MainContent .solari-categories .solari-kicker',
    '#MainContent .solari-categories h2',
    '#MainContent .solari-content-grid__heading .solari-kicker',
    '#MainContent .solari-content-grid__heading h2'
  ].join(', ');
  const panelSelector = [
    '#MainContent .solari-promos .solari-promo',
    '#MainContent .solari-products__grid > *',
    '#MainContent .solari-mission__media',
    '#MainContent .solari-categories__cards > *',
    '#MainContent .solari-strengths__grid > *',
    '#MainContent .solari-insights__grid > *',
    '#MainContent .solari-content-grid__cards > *',
    '#MainContent .solari-service-card',
    '#MainContent .solari-gallery-grid__item',
    '#MainContent .solari-accordion__item',
    '#MainContent .solari-contact-detail',
    '#MainContent .solari-appointment__form'
  ].join(', ');

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(({ target, isIntersecting }) => {
      if (!isIntersecting) return;
      target.classList.add('is-revealed');
      observer.unobserve(target);
      if (target.dataset.solariMotion === 'panel') {
        // Restore each card's original hover transition once its entrance ends.
        window.setTimeout(() => target.removeAttribute('data-solari-motion'), 1100);
      }
    });
  }, { rootMargin: '0px 0px -15% 0px', threshold: 0.01 });

  const find = (root, selector) => {
    const elements = [...root.querySelectorAll(selector)];
    if (root instanceof Element && root.matches(selector)) elements.unshift(root);
    return elements;
  };

  const prepareWords = (element) => {
    if (element.dataset.solariMotionPrepared || element.children.length) return false;
    const words = element.textContent.trim().split(/\s+/u).filter(Boolean);
    if (!words.length) return false;
    const fragment = document.createDocumentFragment();
    words.forEach((word, index) => {
      const mask = document.createElement('span');
      const inner = document.createElement('span');
      mask.className = 'solari-motion-word-mask';
      inner.className = 'solari-motion-word';
      inner.style.setProperty('--solari-word-delay', `${index * 30}ms`);
      inner.textContent = word;
      mask.append(inner);
      fragment.append(mask);
      if (index < words.length - 1) fragment.append(document.createTextNode(' '));
    });
    element.replaceChildren(fragment);
    element.dataset.solariMotion = 'words';
    element.dataset.solariMotionPrepared = 'true';
    return true;
  };

  const prepare = (root = document) => {
    const targets = [];
    find(root, headingSelector).forEach((element) => {
      if (prepareWords(element)) targets.push(element);
    });
    find(root, panelSelector).forEach((element) => {
      if (element.dataset.solariMotionPrepared) return;
      const siblingIndex = [...element.parentElement.children].indexOf(element);
      element.style.setProperty('--solari-motion-delay', `${Math.min(siblingIndex, 4) * 75}ms`);
      element.dataset.solariMotion = 'panel';
      element.dataset.solariMotionPrepared = 'true';
      targets.push(element);
    });
    if (!targets.length) return;
    document.documentElement.classList.add('solari-motion-ready');
    requestAnimationFrame(() => targets.forEach((element) => observer.observe(element)));
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => prepare(), { once: true });
  else prepare();
  document.addEventListener('shopify:section:load', (event) => prepare(event.target));
})();
